/**
 * Source unique de vérité : les 247 territoires du SVG (voir world-map/countries-list
 * publié en artefact pour la liste complète), chacun avec son nom français.
 * Par défaut tous non publiés (gris, tooltip avec le vrai nom, non cliquables).
 *
 * Une thématique (guide, culture, gastronomie, traditions, climat, activités) ne
 * redéfinit QUE les pays qu'elle publie, via buildTheme(overrides) ci-dessous —
 * jamais besoin de retoucher cette liste de base pour ajouter une page.
 */
window.WORLD_MAP_ALL_COUNTRIES = {
  af: { published: false, url: "", label: "Afghanistan" },
  za: { published: false, url: "", label: "Afrique du Sud" },
  al: { published: false, url: "", label: "Albanie" },
  dz: { published: false, url: "", label: "Algérie" },
  de: { published: false, url: "", label: "Allemagne" },
  ad: { published: false, url: "", label: "Andorre" },
  ao: { published: false, url: "", label: "Angola" },
  ai: { published: false, url: "", label: "Anguilla" },
  aq: { published: false, url: "", label: "Antarctique" },
  ag: { published: false, url: "", label: "Antigua-et-Barbuda" },
  sa: { published: false, url: "", label: "Arabie saoudite" },
  ar: { published: false, url: "", label: "Argentine" },
  am: { published: false, url: "", label: "Arménie" },
  aw: { published: false, url: "", label: "Aruba" },
  au: { published: false, url: "", label: "Australie" },
  at: { published: false, url: "", label: "Autriche" },
  az: { published: false, url: "", label: "Azerbaïdjan" },
  bs: { published: false, url: "", label: "Bahamas" },
  bh: { published: false, url: "", label: "Bahreïn" },
  bd: { published: false, url: "", label: "Bangladesh" },
  bb: { published: false, url: "", label: "Barbade" },
  be: { published: false, url: "", label: "Belgique" },
  bz: { published: false, url: "", label: "Belize" },
  bj: { published: false, url: "", label: "Bénin" },
  bm: { published: false, url: "", label: "Bermudes" },
  bt: { published: false, url: "", label: "Bhoutan" },
  by: { published: false, url: "", label: "Biélorussie" },
  bo: { published: false, url: "", label: "Bolivie" },
  ba: { published: false, url: "", label: "Bosnie-Herzégovine" },
  bw: { published: false, url: "", label: "Botswana" },
  br: { published: false, url: "", label: "Brésil" },
  bn: { published: false, url: "", label: "Brunéi Darussalam" },
  bg: { published: false, url: "", label: "Bulgarie" },
  bf: { published: false, url: "", label: "Burkina Faso" },
  bi: { published: false, url: "", label: "Burundi" },
  kh: { published: false, url: "", label: "Cambodge" },
  cm: { published: false, url: "", label: "Cameroun" },
  ca: { published: false, url: "", label: "Canada" },
  cv: { published: false, url: "", label: "Cap-Vert" },
  cl: { published: false, url: "", label: "Chili" },
  cn: { published: false, url: "", label: "Chine" },
  cy: { published: false, url: "", label: "Chypre" },
  co: { published: false, url: "", label: "Colombie" },
  km: { published: false, url: "", label: "Comores" },
  cg: { published: false, url: "", label: "Congo-Brazzaville" },
  cd: { published: false, url: "", label: "Congo-Kinshasa" },
  kp: { published: false, url: "", label: "Corée du Nord" },
  kr: { published: false, url: "", label: "Corée du Sud" },
  cr: { published: false, url: "", label: "Costa Rica" },
  ci: { published: false, url: "", label: "Côte d’Ivoire" },
  xq: { published: false, url: "", label: "Crimée (territoire distinct, rattaché à la Russie dans ce fond de carte)" },
  hr: { published: false, url: "", label: "Croatie" },
  cu: { published: false, url: "", label: "Cuba" },
  cw: { published: false, url: "", label: "Curaçao" },
  dk: { published: false, url: "", label: "Danemark" },
  dj: { published: false, url: "", label: "Djibouti" },
  dm: { published: false, url: "", label: "Dominique" },
  eg: { published: false, url: "", label: "Égypte" },
  ae: { published: false, url: "", label: "Émirats arabes unis" },
  ec: { published: false, url: "", label: "Équateur" },
  er: { published: false, url: "", label: "Érythrée" },
  es: { published: false, url: "", label: "Espagne" },
  ee: { published: false, url: "", label: "Estonie" },
  sz: { published: false, url: "", label: "Eswatini" },
  va: { published: false, url: "", label: "Vatican" },
  fm: { published: false, url: "", label: "États fédérés de Micronésie" },
  us: { published: false, url: "", label: "États-Unis" },
  et: { published: false, url: "", label: "Éthiopie" },
  fj: { published: false, url: "", label: "Fidji" },
  fi: { published: false, url: "", label: "Finlande" },
  fr: { published: false, url: "", label: "France" },
  ga: { published: false, url: "", label: "Gabon" },
  gm: { published: false, url: "", label: "Gambie" },
  ge: { published: false, url: "", label: "Géorgie" },
  gs: { published: false, url: "", label: "Géorgie du Sud et îles Sandwich du Sud" },
  gh: { published: false, url: "", label: "Ghana" },
  gi: { published: false, url: "", label: "Gibraltar" },
  gr: { published: false, url: "", label: "Grèce" },
  gd: { published: false, url: "", label: "Grenade" },
  gl: { published: false, url: "", label: "Groenland" },
  gp: { published: false, url: "", label: "Guadeloupe" },
  gu: { published: false, url: "", label: "Guam" },
  gt: { published: false, url: "", label: "Guatemala" },
  gg: { published: false, url: "", label: "Guernesey" },
  gn: { published: false, url: "", label: "Guinée" },
  gq: { published: false, url: "", label: "Guinée équatoriale" },
  gw: { published: false, url: "", label: "Guinée-Bissau" },
  gy: { published: false, url: "", label: "Guyana" },
  gf: { published: false, url: "", label: "Guyane française" },
  ht: { published: false, url: "", label: "Haïti" },
  hn: { published: false, url: "", label: "Honduras" },
  hu: { published: false, url: "", label: "Hongrie" },
  cx: { published: false, url: "", label: "Île Christmas" },
  im: { published: false, url: "", label: "Île de Man" },
  nf: { published: false, url: "", label: "Île Norfolk" },
  ky: { published: false, url: "", label: "Îles Caïmans" },
  cc: { published: false, url: "", label: "Îles Cocos" },
  ck: { published: false, url: "", label: "Îles Cook" },
  fo: { published: false, url: "", label: "Îles Féroé" },
  hm: { published: false, url: "", label: "Îles Heard et McDonald" },
  fk: { published: false, url: "", label: "Îles Malouines" },
  mp: { published: false, url: "", label: "Îles Mariannes du Nord" },
  mh: { published: false, url: "", label: "Îles Marshall" },
  pn: { published: false, url: "", label: "Îles Pitcairn" },
  sb: { published: false, url: "", label: "Îles Salomon" },
  tc: { published: false, url: "", label: "Îles Turques-et-Caïques" },
  vg: { published: false, url: "", label: "Îles Vierges britanniques" },
  vi: { published: false, url: "", label: "Îles Vierges des États-Unis" },
  in: { published: false, url: "", label: "Inde" },
  id: { published: false, url: "", label: "Indonésie" },
  iq: { published: false, url: "", label: "Irak" },
  ir: { published: false, url: "", label: "Iran" },
  ie: { published: false, url: "", label: "Irlande" },
  is: { published: false, url: "", label: "Islande" },
  il: { published: false, url: "", label: "Israël" },
  it: { published: false, url: "", label: "Italie" },
  jm: { published: false, url: "", label: "Jamaïque" },
  jp: { published: false, url: "", label: "Japon" },
  je: { published: false, url: "", label: "Jersey" },
  jo: { published: false, url: "", label: "Jordanie" },
  kz: { published: false, url: "", label: "Kazakhstan" },
  ke: { published: false, url: "", label: "Kenya" },
  kg: { published: false, url: "", label: "Kirghizistan" },
  ki: { published: false, url: "", label: "Kiribati" },
  kw: { published: false, url: "", label: "Koweït" },
  re: { published: false, url: "", label: "La Réunion" },
  la: { published: false, url: "", label: "Laos" },
  ls: { published: false, url: "", label: "Lesotho" },
  lv: { published: false, url: "", label: "Lettonie" },
  lb: { published: false, url: "", label: "Liban" },
  lr: { published: false, url: "", label: "Libéria" },
  ly: { published: false, url: "", label: "Libye" },
  li: { published: false, url: "", label: "Liechtenstein" },
  lt: { published: false, url: "", label: "Lituanie" },
  lu: { published: false, url: "", label: "Luxembourg" },
  mk: { published: false, url: "", label: "Macédoine du Nord" },
  mg: { published: false, url: "", label: "Madagascar" },
  my: { published: false, url: "", label: "Malaisie" },
  mw: { published: false, url: "", label: "Malawi" },
  mv: { published: false, url: "", label: "Maldives" },
  ml: { published: false, url: "", label: "Mali" },
  mt: { published: false, url: "", label: "Malte" },
  ma: { published: false, url: "", label: "Maroc" },
  mq: { published: false, url: "", label: "Martinique" },
  mu: { published: false, url: "", label: "Maurice" },
  mr: { published: false, url: "", label: "Mauritanie" },
  yt: { published: false, url: "", label: "Mayotte" },
  mx: { published: false, url: "", label: "Mexique" },
  md: { published: false, url: "", label: "Moldavie" },
  mc: { published: false, url: "", label: "Monaco" },
  mn: { published: false, url: "", label: "Mongolie" },
  me: { published: false, url: "", label: "Monténégro" },
  ms: { published: false, url: "", label: "Montserrat" },
  mz: { published: false, url: "", label: "Mozambique" },
  mm: { published: false, url: "", label: "Myanmar (Birmanie)" },
  na: { published: false, url: "", label: "Namibie" },
  nr: { published: false, url: "", label: "Nauru" },
  np: { published: false, url: "", label: "Népal" },
  ni: { published: false, url: "", label: "Nicaragua" },
  ne: { published: false, url: "", label: "Niger" },
  ng: { published: false, url: "", label: "Nigéria" },
  nu: { published: false, url: "", label: "Niue" },
  no: { published: false, url: "", label: "Norvège" },
  nc: { published: false, url: "", label: "Nouvelle-Calédonie" },
  nz: { published: false, url: "", label: "Nouvelle-Zélande" },
  om: { published: false, url: "", label: "Oman" },
  ug: { published: false, url: "", label: "Ouganda" },
  uz: { published: false, url: "", label: "Ouzbékistan" },
  pk: { published: false, url: "", label: "Pakistan" },
  pw: { published: false, url: "", label: "Palaos" },
  pa: { published: false, url: "", label: "Panama" },
  pg: { published: false, url: "", label: "Papouasie-Nouvelle-Guinée" },
  py: { published: false, url: "", label: "Paraguay" },
  nl: { published: false, url: "", label: "Pays-Bas" },
  bq: { published: false, url: "", label: "Pays-Bas caribéens" },
  pe: { published: false, url: "", label: "Pérou" },
  ph: { published: false, url: "", label: "Philippines" },
  pl: { published: false, url: "", label: "Pologne" },
  pf: { published: false, url: "", label: "Polynésie française" },
  pr: { published: false, url: "", label: "Porto Rico" },
  pt: { published: false, url: "", label: "Portugal" },
  qa: { published: false, url: "", label: "Qatar" },
  hk: { published: false, url: "", label: "R.A.S. chinoise de Hong Kong" },
  mo: { published: false, url: "", label: "R.A.S. chinoise de Macao" },
  cf: { published: false, url: "", label: "République centrafricaine" },
  do: { published: false, url: "", label: "République dominicaine" },
  ro: { published: false, url: "", label: "Roumanie" },
  gb: { published: false, url: "", label: "Royaume-Uni" },
  ru: { published: false, url: "", label: "Russie" },
  rw: { published: false, url: "", label: "Rwanda" },
  eh: { published: false, url: "", label: "Sahara occidental" },
  bl: { published: false, url: "", label: "Saint-Barthélemy" },
  kn: { published: false, url: "", label: "Saint-Christophe-et-Niévès" },
  sm: { published: false, url: "", label: "Saint-Marin" },
  mf: { published: false, url: "", label: "Saint-Martin" },
  sx: { published: false, url: "", label: "Saint-Martin (partie néerlandaise)" },
  pm: { published: false, url: "", label: "Saint-Pierre-et-Miquelon" },
  vc: { published: false, url: "", label: "Saint-Vincent-et-les-Grenadines" },
  sh: { published: false, url: "", label: "Sainte-Hélène" },
  lc: { published: false, url: "", label: "Sainte-Lucie" },
  sv: { published: false, url: "", label: "Salvador" },
  ws: { published: false, url: "", label: "Samoa" },
  as: { published: false, url: "", label: "Samoa américaines" },
  st: { published: false, url: "", label: "Sao Tomé-et-Principe" },
  sn: { published: false, url: "", label: "Sénégal" },
  rs: { published: false, url: "", label: "Serbie" },
  sc: { published: false, url: "", label: "Seychelles" },
  sl: { published: false, url: "", label: "Sierra Leone" },
  sg: { published: false, url: "", label: "Singapour" },
  sk: { published: false, url: "", label: "Slovaquie" },
  si: { published: false, url: "", label: "Slovénie" },
  so: { published: false, url: "", label: "Somalie" },
  sd: { published: false, url: "", label: "Soudan" },
  ss: { published: false, url: "", label: "Soudan du Sud" },
  lk: { published: false, url: "", label: "Sri Lanka" },
  se: { published: false, url: "", label: "Suède" },
  ch: { published: false, url: "", label: "Suisse" },
  sr: { published: false, url: "", label: "Suriname" },
  xv: { published: false, url: "", label: "Svalbard (Norvège)" },
  sy: { published: false, url: "", label: "Syrie" },
  tj: { published: false, url: "", label: "Tadjikistan" },
  tw: { published: false, url: "", label: "Taïwan" },
  tz: { published: false, url: "", label: "Tanzanie" },
  td: { published: false, url: "", label: "Tchad" },
  cz: { published: false, url: "", label: "Tchéquie" },
  tf: { published: false, url: "", label: "Terres australes françaises" },
  io: { published: false, url: "", label: "Territoire britannique de l’océan Indien" },
  ps: { published: false, url: "", label: "Territoires palestiniens" },
  th: { published: false, url: "", label: "Thaïlande" },
  tl: { published: false, url: "", label: "Timor oriental" },
  tg: { published: false, url: "", label: "Togo" },
  tk: { published: false, url: "", label: "Tokelau" },
  to: { published: false, url: "", label: "Tonga" },
  tt: { published: false, url: "", label: "Trinité-et-Tobago" },
  tn: { published: false, url: "", label: "Tunisie" },
  tm: { published: false, url: "", label: "Turkménistan" },
  tr: { published: false, url: "", label: "Turquie" },
  tv: { published: false, url: "", label: "Tuvalu" },
  ua: { published: false, url: "", label: "Ukraine" },
  uy: { published: false, url: "", label: "Uruguay" },
  vu: { published: false, url: "", label: "Vanuatu" },
  ve: { published: false, url: "", label: "Venezuela" },
  vn: { published: false, url: "", label: "Vietnam" },
  wf: { published: false, url: "", label: "Wallis-et-Futuna" },
  ye: { published: false, url: "", label: "Yémen" },
  zm: { published: false, url: "", label: "Zambie" },
  zw: { published: false, url: "", label: "Zimbabwe" },
};

/**
 * SEULE chose à modifier pour publier un pays sur le site : son code et son slug.
 *
 * Chaque pays sort avec ses 7 pages d'un coup (le hub /pages/<slug> + les 6
 * déclinaisons /pages/<slug>-<thematique>). world-map.js construit les 7 URLs
 * lui-même à partir du slug — rien d'autre à maintenir ici.
 *
 * Les formulations "de la France" / "en France" (pour le bouton du popup) sont
 * déduites automatiquement du nom du pays par world-map.js — aucun champ
 * supplémentaire à remplir. Les rares cas irréguliers (pluriels, îles sans
 * article, etc.) se corrigent dans WORLD_MAP_GRAMMAR_EXCEPTIONS ci-dessous,
 * uniquement quand la règle générale se trompe.
 */
window.WORLD_MAP_PUBLISHED_COUNTRIES = {
  al: "albanie",
  de: "allemagne",
  ad: "andorre",
  at: "autriche",
  be: "belgique",
  by: "bielorussie",
  ba: "bosnie-herzegovine",
  bg: "bulgarie",
  cy: "chypre",
  hr: "croatie",
  dk: "danemark",
  es: "espagne",
  ee: "estonie",
  fi: "finlande",
  fr: "france",
  gr: "grece",
  hu: "hongrie",
  ie: "irlande",
  is: "islande",
  it: "italie",
  lv: "lettonie",
  li: "liechtenstein",
  lt: "lituanie",
  lu: "luxembourg",
  mk: "macedoine-du-nord",
  mt: "malte",
  md: "moldavie",
  mc: "monaco",
  me: "montenegro",
  no: "norvege",
  nl: "pays-bas",
  pl: "pologne",
  pt: "portugal",
  cz: "tchequie",
  ro: "roumanie",
  gb: "royaume-uni",
  sm: "saint-marin",
  rs: "serbie",
  sk: "slovaquie",
  si: "slovenie",
  se: "suede",
  ch: "suisse",
  ua: "ukraine",
  va: "vatican",
  ru: "russie",
au: "australie",
fm: "etats-federes-de-micronesie",
fj: "fidji",
ki: "kiribati",
mh: "iles-marshall",
nr: "nauru",
nz: "nouvelle-zelande",
pw: "palaos",
pg: "papouasie-nouvelle-guinee",
ws: "samoa",
sb: "iles-salomon",
to: "tonga",
tv: "tuvalu",
vu: "vanuatu",
ca: "canada",
us: "etats-unis",
mx: "mexique",
br: "bresil",
uy: "uruguay",
cl: "chili",
gt: "guatemala",
cu: "cuba",
bo: "bolivie",
pe: "perou",
ve: "venezuela",
bz: "belize",
bs: "bahamas",
gy: "guyana",
ht: "haiti",
sv: "salvador",
ni: "nicaragua",
hn: "honduras",
cr: "costa-rica",
sr: "suriname",
py: "paraguay",
jm: "jamaique",
ec: "equateur",
co: "colombie",
pa: "panama",
dm: "dominique",
vc: "saint-vincent-et-les-grenadines",
ar: "argentine",
do: "republique-dominicaine",
bb: "barbade",
tt: "trinite-et-tobago",
za: "afrique-du-sud",
ke: "kenya",
eg: "egypte",
ma: "maroc",
vn: "vietnam",
tz: "tanzanie",
id: "indonesie",
in: "inde",
ag: "antigua-et-barbuda",
kn: "saint-christophe-et-nieves",
lc: "sainte-lucie",
kr: "coree-du-sud",
om: "oman",
lk: "sri-lanka",
kh: "cambodge",
ng: "nigeria",
uz: "ouzbekistan",
ae: "emirats-arabes-unis",
gh: "ghana",
il: "israel",
mg: "madagascar",
jo: "jordanie",
na: "namibie",
np: "nepal",
sa: "arabie-saoudite",
qa: "qatar",
TN: "tunisie",
TH: "thailande",
MY: "malaisie",
SG: "singapour",
sy: "syrie",
so: "somalie",
tj: "tadjikistan",
  // Kosovo : absent volontairement (non représenté séparément dans le SVG).
};

/**
 * Exceptions à la règle générale "de la/du/de l' X" et "en/au/à X" (voir la
 * fonction frenchForms() dans world-map.js pour la règle par défaut).
 * N'ajoute une entrée ici QUE si la règle générale donne un résultat faux.
 *
 * Catégories les plus fréquentes :
 *  - pluriels (Pays-Bas, États-Unis, Émirats arabes unis, Philippines...)
 *  - masculins malgré une terminaison en "e" (Royaume-Uni, Mexique, Cambodge...)
 *  - îles / cités-États sans article (Monaco, Malte, Chypre, Singapour...)
 */
window.WORLD_MAP_GRAMMAR_EXCEPTIONS = {
  // Pluriels
  nl: { de: "des Pays-Bas", en: "aux Pays-Bas" },
  us: { de: "des États-Unis", en: "aux États-Unis" },
  ae: { de: "des Émirats arabes unis", en: "aux Émirats arabes unis" },
  ph: { de: "des Philippines", en: "aux Philippines" },
  km: { de: "des Comores", en: "aux Comores" },
  sc: { de: "des Seychelles", en: "aux Seychelles" },
  mv: { de: "des Maldives", en: "aux Maldives" },
  bs: { de: "des Bahamas", en: "aux Bahamas" },
  fj: { de: "des Fidji", en: "aux Fidji" },

  // Masculins malgré une terminaison en "e"
  gb: { de: "du Royaume-Uni", en: "au Royaume-Uni" },
  mx: { de: "du Mexique", en: "au Mexique" },
  kh: { de: "du Cambodge", en: "au Cambodge" },
  zw: { de: "du Zimbabwe", en: "au Zimbabwe" },
  mz: { de: "du Mozambique", en: "au Mozambique" },
  bz: { de: "du Belize", en: "au Belize" },

  // Îles / cités-États traitées sans article
  mc: { de: "de Monaco", en: "à Monaco" },
  sm: { de: "de Saint-Marin", en: "à Saint-Marin" },
  cy: { de: "de Chypre", en: "à Chypre" },
  mt: { de: "de Malte", en: "à Malte" },
  sg: { de: "de Singapour", en: "à Singapour" },
  cu: { de: "de Cuba", en: "à Cuba" }
};
